import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { createSelector } from 'reselect';
import { CROP } from '../../../../appConstants';
import TrapTypeFunctions from '../../../../store/masterData/trap/trapType/functions';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';
import { ITrapType } from '../../../../types/model/masterData/trap/trapType';
import { Card, IconButton, Tooltip } from '@material-ui/core';
import MaterialTable from '../../../customComponents/materialTable/Table';
import { Add, Check, Close, Edit } from '@material-ui/icons';
import StandardFab from '../../../customComponents/button/StandardFab';
import TrapTypeEditDialog from './dialog/Edit';
import moment from 'moment';

interface ITrapTypeListProps extends RouteComponentProps {
    types : Array<ITrapType>;
    isLoading : boolean;
}

interface ITrapTypeListState {
    selected : ITrapType | null;
}

class TrapTypeListComponent extends React.PureComponent<ITrapTypeListProps, ITrapTypeListState> {
    constructor(props : ITrapTypeListProps) {
        super(props);
        this.state = {
            selected: null,
        };
    }

    public readonly componentDidMount = () => {
        this.load();
    };

    public readonly load = () => {
        TrapTypeFunctions.getList();
    };

    public onAddClick = () => {
        this.setState({
            selected: {
                id: '',
                crop: this.getCrop(this.props) ?? 'almonds',
                insects: [],
                name: '',
                isActive: true,
                createdBy: '',
                createdByEmployee: '',
                createdByName: '',
                createdOn: moment.utc().valueOf(),
                updatedBy: '',
                updatedByEmployee: '',
                updatedByName: '',
                updatedOn: moment.utc().valueOf(),
            },
        });
    };

    private readonly getSearch = (props : ITrapTypeListProps) => props.location.search;
    private readonly getData = (props : ITrapTypeListProps) => props.types;

    private getCrop = createSelector(
        [this.getSearch],
        (search) => {
            const urlParams = new URLSearchParams(search);
            if (urlParams.has('crop')) {
                const crop = urlParams.get('crop');
    
                if (crop) {
                    return crop as CROP;
                }
            }

            return null;
        },
    );

    private readonly getTypes = createSelector(
        [
            this.getData,
            this.getCrop,
        ],
        (types, crop) => {
            return types.filter(x => x.crop === crop);
        },
    );

    private readonly onEditClick = (event : React.MouseEvent<HTMLButtonElement>) => {
        const {
            types,
        } = this.props;

        const value = types.find(x => x.id === event.currentTarget.value);
        if (!value) return;

        this.setState({
            selected: {
                ...value,
            },
        });
    };

    private readonly onEditClose = () => {
        this.setState({
            selected: null,
        });
    };

    public render = () => {
        const {
            isLoading,
        } = this.props;
        const {
            selected,
        } = this.state;

        const types = this.getTypes(this.props);
        
        return (
            <div className={'fdc hfill mh0 mw0 bcg0'}>
                <div className='fdc flx1 p20'>
                    <Card className={'flx1 fdc mb70'}>
                        <MaterialTable<ITrapType>
                            id='typesTable'
                            data={types}
                            rowsPerPage={50}
                            isLoading={isLoading}
                            columns={[{
                                header: '',
                                paddingRight: 4,
                                width: 10,
                                renderCell: row => (
                                    <div className='aic'>
                                        <Tooltip title='Edit'>
                                            <div>
                                                <IconButton color='primary' value={row.id} disabled={isLoading} onClick={this.onEditClick}>
                                                    <Edit />
                                                </IconButton>
                                            </div>
                                        </Tooltip>
                                    </div>
                                ),
                            }, {
                                header: 'Name',
                                field: 'name',
                                width: 145,
                                enableSort: true,
                                enableFilter: true,
                            }, {
                                header: 'Insects',
                                field: 'insects',
                                width: 145,
                                enableSort: true,
                                renderCell: row => (row.insects.length),
                            }, {
                                header: 'Is Active?',
                                field: 'isActive',
                                width: 145,
                                enableSort: true,
                                enableFilter: true,
                                renderCell: n => !n.isActive ? (<Close className='cpr' />) : (<Check className='cdg' />),
                            }]}
                        />
                    </Card>
                    <TrapTypeEditDialog
                        value={selected}
                        onClose={this.onEditClose}
                        isLoading={isLoading}
                    />
                </div>
                <div className='fdr aife jcfe'>
                    <Tooltip title='Create'>
                        <div>
                            <StandardFab aria-label='add' disabled={isLoading} onClick={this.onAddClick}>
                                <Add />
                            </StandardFab>
                        </div>
                    </Tooltip>
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        types: state.masterData.trap.trapType.types,
        isLoading: state.masterData.trap.trapType.isLoading,
    };
};


const TrapTypeList = withRouter(connect(
    mapStateToProps,
)(TrapTypeListComponent));

export default TrapTypeList;